// extracted by mini-css-extract-plugin
export default {"contents":"NG-z","sectionHeading":"OG-z"};